import { render, staticRenderFns } from "./UserVariableComponent.vue?vue&type=template&id=96c782d6&scoped=true&"
import script from "./UserVariableComponent.vue?vue&type=script&lang=js&"
export * from "./UserVariableComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserVariableComponent.vue?vue&type=style&index=0&id=96c782d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c782d6",
  null
  
)

export default component.exports